export var memoryStorage = function memoryStorage() {
  var credential;
  return {
    store: function store(cred) {
      credential = cred;
      return Promise.resolve();
    },
    load: function load() {
      return Promise.resolve(credential);
    }
  };
};